import type { QueryClient } from '@tanstack/react-query';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import { configurationQueryKey } from '../../../../../hooks/queries/keys';

export const getCachedConfiguration = (
  queryClient: QueryClient,
  sessionId: number
) => {
  const queryKey = configurationQueryKey(String(sessionId));
  const state = queryClient.getQueryState(queryKey);

  if (state?.isInvalidated) {
    return undefined;
  }

  return queryClient.getQueryData<DeviceConfigurationApi>(queryKey);
};
